import { Action, Dispatch } from "redux";
import { ThunkAction } from "redux-thunk";

import { AppId, ExportPlatform, ExportReturn } from "api";
import { Credentials } from "auth";
import { State } from "redux/state";

export type ExportApp = "EXPORT_APP";
export const EXPORT_APP: ExportApp = "EXPORT_APP";
export type ExportAppEnd = "EXPORT_APP_END";
export const EXPORT_APP_END: ExportAppEnd = "EXPORT_APP_END";

export interface ExportAppAction extends Action {
    payload: {
        appId: AppId;
        credentials: Credentials;
        platform: ExportPlatform;
    };
    type: ExportApp;
}

export function exportApp(
    appId: AppId,
    platform: ExportPlatform
): ThunkAction<void, State, undefined, ExportAppAction> {
    return (dispatch: Dispatch<ExportAppAction>, getState) => {
        const credentials = getState().auth.credentials;

        dispatch(exportAppWithCredentials(appId, platform, credentials));
    };
}

export function exportAppWithCredentials(
    appId: AppId,
    platform: ExportPlatform,
    credentials: Credentials
): ExportAppAction {
    return {
        payload: {
            appId: appId,
            credentials: credentials,
            platform: platform
        },
        type: EXPORT_APP
    };
}

export interface ExportAppEndAction extends Action {
    payload: {
        error?: Error;
        content?: string;
    };
    type: ExportAppEnd;
}

export function exportAppEnd(error?: Error, exportReturn?: ExportReturn): ExportAppEndAction {
    return {
        payload: {
            content: exportReturn ? exportReturn.content : undefined,
            error
        },
        type: EXPORT_APP_END
    };
}
